import { Component, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ResetPasswordService } from './reset.service';
import { CustomValidators } from '../../shared/forms/custom-validators';

@Component({
  selector: 'request-reset',
  templateUrl: 'request.reset.component.html',
  providers: [ResetPasswordService]

})
export class RequestResetComponent {
  @Output() requestPassword = new EventEmitter();

  isLoading: boolean = false;
  resetPasswordForm: FormGroup;
  error = '';

  constructor(
    private _fb: FormBuilder,
    private _resetPasswordService: ResetPasswordService
  ) {
    this.resetPasswordForm = this._fb.group(
      {
        username: ['', Validators.compose([
          Validators.required,
          CustomValidators.email
        ])]
      }
    );
  }

  public onSubmit(event): void {
    event.preventDefault();
    this.error = '';

    if (this.resetPasswordForm.valid) {
      this.isLoading = true;
      this._resetPasswordService.requestResetPassword(this.resetPasswordForm.value)
        .finally(() => this.isLoading = false)
        .subscribe(
          response => this.requestPassword.emit({ message: "Hemos enviado un correo electrónico con los datos proporcionados" }),
          err => this.error = err
        );
    }
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/account/reset/request.reset.component.ts